import { AnyObject } from 'final-form'

type HandlePreferences = (
  values: AnyObject,
  selectedPreferences: { digital: string; email: string; sms: string },
  change: (key: string, value: boolean) => void,
  setPreferences: ({ digital, email, sms }: Record<string, string>) => void,
) => void

const handlePreferences: HandlePreferences = (values, selectedPreferences, change, setPreferences) => {
  if (!values || !selectedPreferences || !change || !selectedPreferences) {
    return
  }
  const { preferenceDigital, preferenceEmail, preferenceSms } = values
  const { digital, email, sms } = selectedPreferences
  if (preferenceDigital !== digital || preferenceEmail !== email || preferenceSms !== sms) {
    if (digital && (preferenceEmail || preferenceSms)) {
      change('preferenceDigital', false)
    } else if (!digital && !preferenceEmail && !preferenceSms) {
      change('preferenceDigital', true)
    } else if ((email || sms) && preferenceDigital) {
      change('preferenceEmail', false)
      change('preferenceSms', false)
    }
    setPreferences({
      digital: preferenceDigital,
      email: preferenceEmail,
      sms: preferenceSms,
    })
  }
}

export default handlePreferences
